export default "__VITE_ASSET__9GjeaBpY__"